export const EXTERIOR_FINISH_EDGE_ANGLE_ATTRIBUTE = "angle";
export const EXTERIOR_FINISH_EDGE_TYPE_ATTRIBUTE = "edgeType";
export const EXTERIOR_FINISH_EDGE_SIDE_ATTRIBUTE = "side";
export const EXTERIOR_FINISH_EDGE_GEOMETRY_TYPE_ATTRIBUTE = "geometryType";

export type ExteriorFinishEdgeType = "OUTSIDE_CORNER" | "INSIDE_CORNER" | "COPLANAR";

export type ExteriorFinishEdgeOpeningSide = "TOP" | "SIDE" | "BOTTOM";
export type ExteriorFinishEdgeGeometryType = "STRAIGHT" | "CURVED";
